import { atom } from 'jotai';

export const indexMetadataAtom = atom(null);
export const hasRequestAtom = atom(null);
